/**
 * @generated SignedSource<<f43c698c21d5a9c3073a45098ca4541b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileSummaryNewPane_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobilePromotion_item" | "CheckoutMobileSummaryNewPaneTitle_item" | "CheckoutMobileSummaryPriceTable_item" | "CheckoutSummaryItemSkuDetails_item">;
  readonly " $fragmentType": "CheckoutMobileSummaryNewPane_item";
};
export type CheckoutMobileSummaryNewPane_item$key = {
  readonly " $data"?: CheckoutMobileSummaryNewPane_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryNewPane_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileSummaryNewPane_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryNewPaneTitle_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSummaryItemSkuDetails_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryPriceTable_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobilePromotion_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "400613e49cf75b1be2fedaebcee174a9";

export default node;
